module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog-components/blog-list/blog-list.component.css
// module id = ./src/app/blog-components/blog-list/blog-list.component.css
// module chunks = main